import Joi from '@hapi/joi'

export const scheduleSOSchema = Joi.object({
  number: Joi.number().default(0),
  serviceOrderType: Joi.string().required(),
  status: Joi.string().allow(null).optional(),
  id: Joi.string().uuid().allow('').optional(),
  note: Joi.alternatives().conditional('id', {
    is: Joi.exist(),
    then: Joi.string().required(),
    otherwise: Joi.string().allow('', null).optional(),
  }),
  dayShift: Joi.string().allow(null, '').optional(),
  scheduleDate: Joi.number().allow(null).optional(),
  schedulePeriod: Joi.string().allow(null, '').optional(),
  scheduleDateInput: Joi.string().allow(null, '').optional(),
  scheduleType: Joi.string()
    .valid('BUSINESS_HOURS', 'DAY_SHIFT', 'FIXED_SCHEDULE')
    .default('BUSINESS_HOURS'),
  time: Joi.string().when('scheduleType', {
    is: 'FIXED_SCHEDULE',
    then: Joi.string().min(1).required(),
    otherwise: Joi.string().allow('').default(''),
  }),
  account: Joi.object({
    id: Joi.string().required(),
    code: Joi.string().required(),
    aggregatedName: Joi.string().required(),
  }).required(),
  technician: Joi.object({
    id: Joi.string().required(),
    name: Joi.string().required(),
  })
    .allow(null)
    .optional(),
  tags: Joi.array()
    .items(
      Joi.object({
        name: Joi.string().required(),
      }),
    )
    .optional()
    .allow(null),
  calendarWeekInterval: Joi.object({
    startDate: Joi.number().required(),
    endDate: Joi.number().required(),
  }).required(),
  customer: Joi.object({
    id: Joi.string().required(),
    name: Joi.string().required(),
  }).required(),
  labels: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().required(),
        description: Joi.string().required(),
        type: Joi.string()
          .valid('ISSUE', 'ORIGIN', 'PAUSE_REASON', 'REASON', 'RESOLUTION')
          .required(),
        active: Joi.boolean().optional(),
      }),
    )
    .optional(),
})
